import AsyncStorage from '@react-native-async-storage/async-storage';
import {clientConfigPath} from '../../config/Constant';
import {AesUtil} from '../../js/AesUtil';
import { setGuestItineraryList } from '../Reducers/guestItineraryReducer';

// Function to group payload by dates
const groupByDate = payload => {
  const grouped = payload.reduce((acc, item) => {
    const itineraryDate = item.itineraryDateTime.split(' ')[0]; // Extract the date part
    const existingGroup = acc.find(
      group => group.itineraryDate === itineraryDate,
    );
    if (existingGroup) {
      existingGroup.itineraries.push(item);
    } else {
      acc.push({itineraryDate, itineraries: [item]});
    }
    return acc;
  }, []);
  return grouped;
};

export const getGuestItineraryList = groupId => {
  return async (dispatch, getState) => {

    const { isBookingFound, bookingData } = getState().checkInSlice.bookingStatus;

    const sessionToken = await AsyncStorage.getItem('sessionToken');

    let requestPayload = {};

    if (isBookingFound) {
      requestPayload = {
        confirmationNumber : bookingData?.confirmationNumber,
        guestLastName: bookingData?.lastName
      }
    }

    try {
      let requestBody = {
        header: {
          sessionToken: sessionToken,
        },
        payload: requestPayload,
      };
      const res = await clientConfigPath.post(
        `/guest/itinerary`,
        requestBody,
      );
      const responsePayload = res?.data?.payload?.payload;;
      const guestItineraryList = groupByDate(responsePayload);
      dispatch(setGuestItineraryList(guestItineraryList));
    } catch (error) {
      console.log('ERROR FETCHING GUEST ITINERARY LIST:', error.message);
    }
  };
};
